import { create } from "zustand";

interface TeamBridgeStore {
  msTeamId: string | null;
  _setMsTeamId: (msTeamId: string | null) => void;
}

// This store serves as a bridge between OfficeProvider and non-React code
// (API service, Fluid client). OfficeProvider reads office route data and sets
// it here so plain JS modules can access it without React hooks.
export const useTeamBridgeStore = create<TeamBridgeStore>((set) => ({
  _setMsTeamId: (msTeamId) => set({ msTeamId }),
  msTeamId: null,
}));
